import { axiosForAnonymousHudson } from '@telialt/utils/src/axios/axiosForAnonymousHudson';
import { axiosWithFetch } from '@telialt/utils/src/axiosWithFetch';
import { withParams } from '@telialt/utils/src/helpers';

import { API } from './constants';
import {
    ProductSearchItem,
    SearchEventsData,
    SearchQueryKeysMap,
    SearchQueryParams,
    SearchQueryResponse,
    SearchRedirections,
    SearchSuggestionsParams,
    SearchSuggestionsResponse,
} from './model';

export const apiGetQueryKeys = async (signal?: AbortSignal) => {
    const response = await axiosForAnonymousHudson.get<SearchQueryKeysMap>(API.URL_SEARCH_QUERY_KEYS, {
        signal,
    });

    return response.data;
};

export const apiGetSuggestionsQuery = (queryKey: string, params: SearchSuggestionsParams, signal?: AbortSignal) =>
    axiosWithFetch.get<SearchSuggestionsResponse>(withParams(API.URL_SEARCH_QUERY, { queryKey }), {
        params,
        signal,
    });

export const apiGetSearchQuery = <ItemType>(
    queryKey: string,
    params: SearchQueryParams,
    signal?: AbortSignal,
    clientIp?: string,
) =>
    axiosWithFetch.get<SearchQueryResponse<ItemType>>(withParams(API.URL_SEARCH_QUERY, { queryKey }), {
        params,
        signal,
        headers: {
            'X-Forwarded-For': clientIp,
        },
    });

export const apiGetRedirections = (queryKey: string, signal?: AbortSignal, clientIp?: string) =>
    axiosWithFetch.get<SearchRedirections>(withParams(API.URL_REDIRECTIONS, { queryKey }), {
        signal,
        headers: {
            'X-Forwarded-For': clientIp,
        },
    });

export const apiPostSearchEvents = (data: SearchEventsData) => axiosWithFetch.post(API.URL_SEARCH_EVENTS, data);

export const apiGetFallbackSearchProductsQuery = (categoryPath: string, offset: number, signal?: AbortSignal) => {
    return axiosForAnonymousHudson.get<SearchQueryResponse<ProductSearchItem>>(API.URL_FALLBACK_SEARCH_PRODUCTS_QUERY, {
        params: {
            categoryPath,
            offset,
        },
        baseURL: '',
        signal,
    });
};
